/*
 * Application Insights JavaScript SDK - Web, 2.8.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
export var _DYN_UPDATE_SNIPPET_DEFIN0 = "updateSnippetDefinitions"; // Count: 4
export var _DYN_LOAD_APP_INSIGHTS = "loadAppInsights"; // Count: 4
export var _DYN_ENDPOINT_URL = "endpointUrl"; // Count: 4
export var _DYN_MAX_BATCH_SIZE_IN_BY1 = "maxBatchSizeInBytes"; // Count: 3
export var _DYN_MAX_BATCH_INTERVAL = "maxBatchInterval"; // Count: 3
export var _DYN_DISABLE_EXCEPTION_TR2 = "disableExceptionTracking"; // Count: 2
export var _DYN_DISABLE_TELEMETRY = "disableTelemetry"; // Count: 2
export var _DYN_EMIT_LINE_DELIMITED_3 = "emitLineDelimitedJson"; // Count: 2
export var _DYN_DIAGNOSTIC_LOG_INTER4 = "diagnosticLogInterval"; // Count: 6
export var _DYN_AUTO_TRACK_PAGE_VISI5 = "autoTrackPageVisitTime"; // Count: 2
export var _DYN_SAMPLING_PERCENTAGE = "samplingPercentage"; // Count: 4
export var _DYN_DISABLE_AJAX_TRACKIN6 = "disableAjaxTracking"; // Count: 2
export var _DYN_MAX_AJAX_CALLS_PER_V7 = "maxAjaxCallsPerView"; // Count: 3
export var _DYN_IS_BEACON_API_DISABL8 = "isBeaconApiDisabled"; // Count: 2
export var _DYN_DISABLE_CORRELATION_9 = "disableCorrelationHeaders"; // Count: 2
export var _DYN_CORRELATION_HEADER_E10 = "correlationHeaderExcludedDomains"; // Count: 2
export var _DYN_DISABLE_FLUSH_ON_BEF11 = "disableFlushOnBeforeUnload"; // Count: 4
export var _DYN_DISABLE_FLUSH_ON_UNL12 = "disableFlushOnUnload"; // Count: 3
export var _DYN_ENABLE_SESSION_STORA13 = "enableSessionStorageBuffer"; // Count: 2
export var _DYN_IS_COOKIE_USE_DISABL14 = "isCookieUseDisabled"; // Count: 2
export var _DYN_IS_STORAGE_USE_DISAB15 = "isStorageUseDisabled"; // Count: 2
export var _DYN_IS_BROWSER_LINK_TRAC16 = "isBrowserLinkTrackingEnabled"; // Count: 2
export var _DYN_ENABLE_CORS_CORRELAT17 = "enableCorsCorrelation"; // Count: 2
export var _DYN_CONFIG = "config"; // Count: 6
export var _DYN_CONTEXT = "context"; // Count: 8
export var _DYN_PUSH = "push"; // Count: 5
export var _DYN_VERSION = "version"; // Count: 6
export var _DYN_QUEUE = "queue"; // Count: 6
export var _DYN_CONNECTION_STRING = "connectionString"; // Count: 3
export var _DYN_INSTRUMENTATION_KEY = "instrumentationKey"; // Count: 2
export var _DYN_APP_INSIGHTS = "appInsights"; // Count: 3
export var _DYN_DISABLE_IKEY_DEPRECA18 = "disableIkeyDeprecationMessage"; // Count: 2
export var _DYN_GET_TRANSMISSION_CON19 = "getTransmissionControls"; // Count: 2
export var _DYN_ONUNLOAD_FLUSH = "onunloadFlush"; // Count: 6
export var _DYN_ADD_HOUSEKEEPING_BEF20 = "addHousekeepingBeforeUnload"; // Count: 2
export var _DYN_INDEX_OF = "indexOf"; // Count: 4
//# sourceMappingURL=__DynamicConstants.js.map